export enum DarTopicNames {
	DAR_CREATED = "dars/created",
	DAR_UPDATED = "dars/updated",
}

export interface DarCreatedTopic {
	darId: string;
}

export enum MedicationIncidentTopicNames {
	MEDICATION_INCIDENT_CREATED = "medication/incidents/created",
	FOUND_MEDICATION_INCIDENT_CREATED = "medication/incidents/found/created",
}
